// src/components/styled.js
import { styled } from "@mui/material/styles";
import { TextValidator } from "react-material-ui-form-validator"; // or your validator package path

export const DecoratedTextField = styled(TextValidator)(() => ({
    width: "100%",
    marginBottom: "16px",
}));